module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-60\">Align</label>\r\n        <div>\r\n            <img id=\"align-left\" name=\"align-left\" src=\"")
    ; __append( require('editor/icons/align_left.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( alignLeftSelection ))
    ; __append("\" />\r\n            <img id=\"align-center\" name=\"align-center\" src=\"")
    ; __append( require('editor/icons/align_center.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( alignCenterSelection ))
    ; __append("\" />\r\n            <img id=\"align-right\" name=\"align-right\" src=\"")
    ; __append( require('editor/icons/align_right.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( alignRightSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}